import { Input } from '@iwoca/orion';
import { Trans, useLingui } from '@lingui/react/macro';
import { useFormContext } from 'react-hook-form';

import styles from './EmailScreen.module.css';
import { TMobileSignupForm } from '../../form/form';
import { StepLayout } from '../../StepLayout/StepLayout';

const EMAIL_REGEX = /.+@.+\..+/;

// DIT-679. Email + consent copy. Minting the application happens on submit
// (DIT-679); nav lands in 0.6. Reads/writes the shared mobile signup form
// store (DIT-664).
export const EmailScreen = () => {
  const { t } = useLingui();
  const { register, watch } = useFormContext<TMobileSignupForm>();

  const email = watch('email');

  return (
    <StepLayout
      stageTitle={t`Credit request`}
      heading={t`What is your business email address?`}
      subHeading={t`You can log in to this application with this email:`}
      ctaDisabled={!EMAIL_REGEX.test(email)}
    >
      <Input
        {...register('email')}
        type="email"
        label={t`Email address`}
        placeholder={t`firstname@example.com`}
        className="fs-mask"
      />
      <p className={styles.legal}>
        <Trans>
          I hereby consent to the processing of my personal data in accordance
          with our current{' '}
          <a
            href="https://www.iwoca.de/datenschutzhinweis/"
            target="_blank"
            rel="noreferrer"
          >
            privacy policy
          </a>{' '}
          of iwoca Deutschland GmbH. This consent can be withdrawn at any time.
          I agree to the{' '}
          <a
            href="https://www.iwoca.de/allgemeine_geschaeftsbedingungen/"
            target="_blank"
            rel="noreferrer"
          >
            terms and conditions
          </a>{' '}
          of iwoca Deutschland GmbH.
        </Trans>
      </p>
    </StepLayout>
  );
};
